import { BiDownArrowCircle } from '@react-icons/all-files/bi/BiDownArrowCircle';
import { BiUpArrowCircle } from '@react-icons/all-files/bi/BiUpArrowCircle';
import React, { useState } from 'react';
import {
  extraContent,
  extraContentOrder1,
  extraContentOrder2,
  aboutUsInfo,
} from './AboutData';

const Banner = () => {
  const [readMore, setReadMore] = useState(false);

  return (
    // Section container with a subtle background color and padding
    <div className="bg-slate-100" id="top">
      {/* Centering and max-width container with responsive padding */}
      <div className="mx-auto max-w-4xl px-4 py-16 text-center sm:py-24 lg:py-32">
        {/* Main heading with responsive text size and bold font */}
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
          Let's Read BabaSaheb
        </h1>

        {/* Paragraph container with responsive text size and spacing */}
        <div className="mt-6 max-w-3xl mx-auto text-lg leading-8 text-gray-700">
          <p>{aboutUsInfo}</p>

          {/* Collapsible section for extra content */}
          <div
            className={`transition-max-height duration-700 ease-in-out overflow-hidden ${
              readMore ? 'max-h-screen' : 'max-h-0'
            }`}
          >
            <div className="mt-4 space-y-4">
              <p>{extraContent}</p>
              <p>{extraContentOrder1}</p>
              <p>{extraContentOrder2}</p>
            </div>
          </div>
        </div>

        {/* "Read More" button with modern styling and icon */}
        <div className="mt-10">
          <button
            type="button"
            onClick={() => setReadMore(!readMore)}
            className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            {readMore ? (
              <>
                Read Less
                <BiUpArrowCircle
                  className="ml-2 -mr-1 h-5 w-5"
                  aria-hidden="true"
                />
              </>
            ) : (
              <>
                Read More
                <BiDownArrowCircle
                  className="ml-2 -mr-1 h-5 w-5"
                  aria-hidden="true"
                />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;
